import React from 'react';
export const LiveIcon = ({ customClass }) => {
  return (
    <svg
      id="Layer_3"
      data-name="Layer 3"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 123 62.97"
    >
      <path
        d="M47.61,12V5.16c.79,0,1.61-.11,2.42-.11q19.38,0,38.76,0A12,12,0,0,1,101.2,17.3c0,2.7,0,5.4,0,8.11,0,.68.06,1.36.11,2.5L123,16.61V62.68c-2.5-1.29-4.88-2.49-7.25-3.73q-9-4.68-17.92-9.39c-.57-.3-1.14-.6-1.68-1A3.45,3.45,0,0,1,94.67,44a3.5,3.5,0,0,1,4.83-1.36c4.06,2.08,8.09,4.22,12.13,6.33,1.35.7,2.72,1.35,4.34,2.15V28.3c-.82.35-1.46.58-2.07.89l-13.31,7c-4.07,2.12-6.39.69-6.4-4,0-4.82,0-9.64,0-14.47,0-3.83-2-5.77-5.85-5.77q-19.29,0-38.57,0Z"
        transform="translate(0 0.29)"
        fill="#1a0c3e"
      />
      <path
        d="M70.63,21.34H86.88v5H76.65v5.75H86.89v5.16H76.63v7H86.88v5.09H70.63Z"
        transform="translate(0 0.29)"
        fill="#ed2224"
      />
      <path
        d="M41,21.36h6.6c2.18,7.11,4.38,14.27,6.53,21.26,2.16-6.91,4.41-14.06,6.66-21.24h6.59c-1.91,5.15-3.75,10.14-5.6,15.12C60.43,40.24,59,44,57.68,47.71a2.18,2.18,0,0,1-2.47,1.74c-3.89-.08-3.88,0-5.26-3.76q-4.1-11.13-8.21-22.24C41.51,22.8,41.3,22.14,41,21.36Z"
        transform="translate(0 0.29)"
        fill="#ed2224"
      />
      <path
        d="M22,5.09V12c-2.42,0-4.89,0-7.37,0A18.26,18.26,0,0,0,11,12.2a4.72,4.72,0,0,0-3.9,5C7,22.48,7,27.74,7,33a3.86,3.86,0,0,1-1.89,3.74C3,37.91.14,36.55.1,34.08,0,27.67-.15,21.22.39,14.84c.47-5.4,5.43-9.49,10.85-9.72C14.81,5,18.39,5.09,22,5.09Z"
        transform="translate(0 0.29)"
        fill="#1a0c3e"
      />
      <path
        d="M26.05,8.45A8.72,8.72,0,0,1,34.7-.29a8.89,8.89,0,0,1,8.95,8.74,9,9,0,0,1-8.84,8.85A8.67,8.67,0,0,1,26.05,8.45Z"
        transform="translate(0 0.29)"
        fill="#1a0c3e"
      />
      <path
        d="M27.77,49.36H12.42v-28h5.82V44.24h9.53Z"
        transform="translate(0 0.29)"
        fill="#ed2224"
      />
      <path d="M32,21.34h5.63v28H32Z" transform="translate(0 0.29)" fill="#ed2224" />
    </svg>
  );
};
export const CardBackground = ({ customClass }) => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 960.19 354.44"
      className="ctabgImage h-100 position-absolute top-0 end-0"
    >
      <rect x="0.19" y="0.08" width="960" height="354" fill="#a8dff4" />
      <path
        d="M959.69,211.67c-42.47-3.22-52.24,19.36-100.44,56.58-48.48,37.43-94.26,32.43-149.35,17-33.84-9.49-65.93-33-96.22-75.57C576.78,157.78,546,95.83,496.16,63.73,400.7,2.21,277,78.28,190.32-.08,163.24,0,144.53,0,144.53,0l-87,.11S19.62,0,0,0C0,118.42-.19,235.94-.19,354.36l960-.55"
        transform="translate(0.19 0.08)"
        fill="#f0efef"
      />
      <path
        d="M0,0,121.61.25h0a115.24,115.24,0,0,1,30.05,29.42c28.2,39.13,42.68,78.54,72.27,114.78,40.34,49.4,94.16,72.13,153.87,62.31,36.94-6.07,73.27-19,110.61-18.23,83,1.69,158.48,74.52,163.7,165.47H0Z"
        transform="translate(0.19 0.08)"
        fill="#fff"
      />
    </svg>
  );
};
export const LeftCorner = () => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 406.54 282.15"
    >
      <rect y="250.26" width="6.87" height="6.87" fill="#a8dff4" />
      <rect x="24.98" y="250.26" width="6.87" height="6.87" fill="#a8dff4" />
      <rect x="49.96" y="250.26" width="6.87" height="6.87" fill="#a8dff4" />
      <rect
        x="0.46"
        y="225.24"
        width="6.87"
        height="6.87"
        transform="translate(-225.24 232.43) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="0.46"
        y="200.23"
        width="6.87"
        height="6.87"
        transform="translate(-200.23 207.42) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="0.46"
        y="175.21"
        width="6.87"
        height="6.87"
        transform="translate(-175.21 182.41) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="0.46"
        y="150.2"
        width="6.87"
        height="6.87"
        transform="translate(-150.2 157.4) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="0.46"
        y="125.19"
        width="6.87"
        height="6.87"
        transform="translate(-125.19 132.39) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="25.44"
        y="225.24"
        width="6.87"
        height="6.87"
        transform="translate(-200.26 257.41) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="25.43"
        y="200.23"
        width="6.87"
        height="6.87"
        transform="translate(-175.25 232.4) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="25.43"
        y="175.21"
        width="6.87"
        height="6.87"
        transform="translate(-150.23 207.39) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="25.44"
        y="150.2"
        width="6.87"
        height="6.87"
        transform="translate(-125.22 182.38) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="25.44"
        y="125.19"
        width="6.87"
        height="6.87"
        transform="translate(-100.21 157.37) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="50.41"
        y="225.24"
        width="6.87"
        height="6.87"
        transform="translate(-175.28 282.39) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="50.41"
        y="200.23"
        width="6.87"
        height="6.87"
        transform="translate(-150.27 257.38) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="50.41"
        y="175.21"
        width="6.87"
        height="6.87"
        transform="translate(-125.25 232.37) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="50.41"
        y="150.2"
        width="6.87"
        height="6.87"
        transform="translate(-100.24 207.36) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="50.41"
        y="125.19"
        width="6.87"
        height="6.87"
        transform="translate(-75.23 182.35) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="0.46"
        y="100.18"
        width="6.87"
        height="6.87"
        transform="translate(-100.18 107.38) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="0.46"
        y="75.17"
        width="6.87"
        height="6.87"
        transform="translate(-75.17 82.36) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="0.46"
        y="50.16"
        width="6.87"
        height="6.87"
        transform="translate(-50.16 57.35) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="0.46"
        y="25.14"
        width="6.87"
        height="6.87"
        transform="translate(-25.14 32.34) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="25.44"
        y="100.18"
        width="6.87"
        height="6.87"
        transform="translate(-75.2 132.36) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="25.43"
        y="75.17"
        width="6.87"
        height="6.87"
        transform="translate(-50.19 107.34) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="25.43"
        y="50.16"
        width="6.87"
        height="6.87"
        transform="translate(-25.18 82.33) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="0.46"
        y="0.13"
        width="6.87"
        height="6.87"
        transform="translate(-0.13 7.33) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="50.41"
        y="100.18"
        width="6.87"
        height="6.87"
        transform="translate(-50.22 157.34) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="0.46"
        y="275.4"
        width="6.87"
        height="6.87"
        transform="translate(-275.4 282.6) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="25.44"
        y="275.4"
        width="6.87"
        height="6.87"
        transform="translate(-250.42 307.58) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="50.41"
        y="275.4"
        width="6.87"
        height="6.87"
        transform="translate(-225.45 332.56) rotate(-90)"
        fill="#a8dff4"
      />
      <rect x="74.94" y="250.26" width="6.87" height="6.87" fill="#a8dff4" />
      <rect x="99.92" y="250.26" width="6.87" height="6.87" fill="#a8dff4" />
      <rect
        x="75.39"
        y="225.24"
        width="6.87"
        height="6.87"
        transform="translate(-150.3 307.37) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="75.39"
        y="200.23"
        width="6.87"
        height="6.87"
        transform="translate(-125.29 282.36) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="75.39"
        y="175.21"
        width="6.87"
        height="6.87"
        transform="translate(-100.27 257.35) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="75.39"
        y="150.2"
        width="6.87"
        height="6.87"
        transform="translate(-75.26 232.34) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="100.37"
        y="225.24"
        width="6.87"
        height="6.87"
        transform="translate(-125.32 332.35) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="75.39"
        y="275.4"
        width="6.87"
        height="6.87"
        transform="translate(-200.47 357.54) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="100.37"
        y="275.4"
        width="6.87"
        height="6.87"
        transform="translate(-175.49 382.52) rotate(-90)"
        fill="#a8dff4"
      />
      <rect x="124.9" y="250.26" width="6.87" height="6.87" fill="#a8dff4" />
      <rect x="149.88" y="250.26" width="6.87" height="6.87" fill="#a8dff4" />
      <rect
        x="125.35"
        y="225.24"
        width="6.87"
        height="6.87"
        transform="translate(-100.34 357.33) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="150.33"
        y="225.24"
        width="6.87"
        height="6.87"
        transform="translate(-75.36 382.31) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="125.35"
        y="275.4"
        width="6.87"
        height="6.87"
        transform="translate(-150.51 407.5) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="150.33"
        y="275.4"
        width="6.87"
        height="6.87"
        transform="translate(-125.53 432.48) rotate(-90)"
        fill="#a8dff4"
      />
      <rect x="174.86" y="250.26" width="6.87" height="6.87" fill="#a8dff4" />
      <rect x="199.84" y="250.26" width="6.87" height="6.87" fill="#a8dff4" />
      <rect
        x="175.31"
        y="225.24"
        width="6.87"
        height="6.87"
        transform="translate(-50.38 407.29) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="200.29"
        y="225.24"
        width="6.87"
        height="6.87"
        transform="translate(-25.4 432.27) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="175.31"
        y="275.4"
        width="6.87"
        height="6.87"
        transform="translate(-100.55 457.46) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="200.29"
        y="275.4"
        width="6.87"
        height="6.87"
        transform="translate(-75.57 482.44) rotate(-90)"
        fill="#a8dff4"
      />
      <rect x="224.82" y="250.26" width="6.87" height="6.87" fill="#a8dff4" />
      <rect x="249.8" y="250.26" width="6.87" height="6.87" fill="#a8dff4" />
      <rect
        x="225.27"
        y="225.24"
        width="6.87"
        height="6.87"
        transform="translate(-0.42 457.25) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="250.25"
        y="225.24"
        width="6.87"
        height="6.87"
        transform="translate(24.56 482.23) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="225.27"
        y="275.4"
        width="6.87"
        height="6.87"
        transform="translate(-50.59 507.42) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="250.25"
        y="275.4"
        width="6.87"
        height="6.87"
        transform="translate(-25.61 532.4) rotate(-90)"
        fill="#a8dff4"
      />
      <rect x="274.78" y="250.26" width="6.87" height="6.87" fill="#a8dff4" />
      <rect x="299.76" y="250.26" width="6.87" height="6.87" fill="#a8dff4" />
      <rect
        x="275.23"
        y="225.24"
        width="6.87"
        height="6.87"
        transform="translate(49.54 507.21) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="275.23"
        y="275.4"
        width="6.87"
        height="6.87"
        transform="translate(-0.63 557.38) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="300.21"
        y="275.4"
        width="6.87"
        height="6.87"
        transform="translate(24.35 582.36) rotate(-90)"
        fill="#a8dff4"
      />
      <rect x="324.74" y="250.26" width="6.87" height="6.87" fill="#a8dff4" />
      <rect x="349.71" y="250.26" width="6.87" height="6.87" fill="#a8dff4" />
      <rect
        x="325.19"
        y="275.4"
        width="6.87"
        height="6.87"
        transform="translate(49.33 607.34) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="350.17"
        y="275.4"
        width="6.87"
        height="6.87"
        transform="translate(74.31 632.32) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="375.15"
        y="275.4"
        width="6.87"
        height="6.87"
        transform="translate(99.29 657.3) rotate(-90)"
        fill="#a8dff4"
      />
      <rect
        x="400.13"
        y="275.4"
        width="6.87"
        height="6.87"
        transform="translate(124.27 682.28) rotate(-90)"
        fill="#a8dff4"
      />
    </svg>
  );
};

export const RightCorner = () => {
  return (
    <svg
      id="Layer_2"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 357.87 226.06"
    >
      <g opacity="0.6000000000000001">
        <rect
          x="352"
          y="21.53"
          width="6.04"
          height="6.04"
          transform="translate(709.87 49.56) rotate(180)"
          fill="#fff"
        />
        <rect
          x="330.01"
          y="21.53"
          width="6.04"
          height="6.04"
          transform="translate(665.9 49.56) rotate(180)"
          fill="#fff"
        />
        <rect
          x="308.02"
          y="21.53"
          width="6.04"
          height="6.04"
          transform="translate(621.92 49.56) rotate(180)"
          fill="#fff"
        />
        <rect
          x="352"
          y="43.65"
          width="6.04"
          height="6.04"
          transform="translate(401.52 -307.9) rotate(90)"
          fill="#fff"
        />
        <rect
          x="352"
          y="65.64"
          width="6.04"
          height="6.04"
          transform="translate(423.51 -285.91) rotate(90)"
          fill="#fff"
        />
        <rect
          x="352"
          y="87.62"
          width="6.04"
          height="6.04"
          transform="translate(445.5 -263.92) rotate(90)"
          fill="#fff"
        />
        <rect
          x="352"
          y="109.61"
          width="6.04"
          height="6.04"
          transform="translate(467.49 -241.93) rotate(90)"
          fill="#fff"
        />
        <rect
          x="352"
          y="131.6"
          width="6.04"
          height="6.04"
          transform="translate(489.48 -219.94) rotate(90)"
          fill="#fff"
        />
        <rect
          x="330.01"
          y="43.65"
          width="6.04"
          height="6.04"
          transform="translate(379.53 -285.91) rotate(90)"
          fill="#fff"
        />
        <rect
          x="330.01"
          y="65.63"
          width="6.04"
          height="6.04"
          transform="translate(401.52 -263.92) rotate(90)"
          fill="#fff"
        />
        <rect
          x="330.01"
          y="87.62"
          width="6.04"
          height="6.04"
          transform="translate(423.51 -241.93) rotate(90)"
          fill="#fff"
        />
        <rect
          x="330.01"
          y="109.61"
          width="6.04"
          height="6.04"
          transform="translate(445.5 -219.94) rotate(90)"
          fill="#fff"
        />
        <rect
          x="330.01"
          y="131.6"
          width="6.04"
          height="6.04"
          transform="translate(467.49 -197.95) rotate(90)"
          fill="#fff"
        />
        <rect
          x="308.02"
          y="43.65"
          width="6.04"
          height="6.04"
          transform="translate(357.54 -263.92) rotate(90)"
          fill="#fff"
        />
        <rect
          x="308.02"
          y="65.63"
          width="6.04"
          height="6.04"
          transform="translate(379.53 -241.93) rotate(90)"
          fill="#fff"
        />
        <rect
          x="308.02"
          y="87.62"
          width="6.04"
          height="6.04"
          transform="translate(401.52 -219.94) rotate(90)"
          fill="#fff"
        />
        <rect
          x="308.02"
          y="109.61"
          width="6.04"
          height="6.04"
          transform="translate(423.51 -197.95) rotate(90)"
          fill="#fff"
        />
        <rect
          x="308.02"
          y="131.6"
          width="6.04"
          height="6.04"
          transform="translate(445.5 -175.96) rotate(90)"
          fill="#fff"
        />
        <rect
          x="352"
          y="153.59"
          width="6.04"
          height="6.04"
          transform="translate(511.47 -197.95) rotate(90)"
          fill="#fff"
        />
        <rect
          x="352"
          y="175.58"
          width="6.04"
          height="6.04"
          transform="translate(533.46 -175.96) rotate(90)"
          fill="#fff"
        />
        <rect
          x="352"
          y="197.57"
          width="6.04"
          height="6.04"
          transform="translate(555.44 -153.97) rotate(90)"
          fill="#fff"
        />
        <rect
          x="352"
          y="219.56"
          width="6.04"
          height="6.04"
          transform="translate(577.43 -131.98) rotate(90)"
          fill="#fff"
        />
        <rect
          x="330.01"
          y="153.59"
          width="6.04"
          height="6.04"
          transform="translate(489.48 -175.96) rotate(90)"
          fill="#fff"
        />
        <rect
          x="330.01"
          y="175.58"
          width="6.04"
          height="6.04"
          transform="translate(511.47 -153.97) rotate(90)"
          fill="#fff"
        />
        <rect
          x="330.01"
          y="197.57"
          width="6.04"
          height="6.04"
          transform="translate(533.46 -131.98) rotate(90)"
          fill="#fff"
        />
        <rect
          x="308.02"
          y="153.59"
          width="6.04"
          height="6.04"
          transform="translate(467.49 -153.97) rotate(90)"
          fill="#fff"
        />
        <rect
          x="308.02"
          y="175.58"
          width="6.04"
          height="6.04"
          transform="translate(489.48 -131.98) rotate(90)"
          fill="#fff"
        />
        <rect
          x="308.02"
          y="197.57"
          width="6.04"
          height="6.04"
          transform="translate(511.47 -109.99) rotate(90)"
          fill="#fff"
        />
        <rect
          x="352"
          y="-0.46"
          width="6.04"
          height="6.04"
          transform="translate(357.41 -352) rotate(90)"
          fill="#fff"
        />
        <rect
          x="330.01"
          y="-0.46"
          width="6.04"
          height="6.04"
          transform="translate(335.42 -330.01) rotate(90)"
          fill="#fff"
        />
        <rect
          x="308.02"
          y="-0.46"
          width="6.04"
          height="6.04"
          transform="translate(313.44 -308.02) rotate(90)"
          fill="#fff"
        />
        <rect
          x="286.03"
          y="21.53"
          width="6.04"
          height="6.04"
          transform="translate(577.94 49.56) rotate(180)"
          fill="#fff"
        />
        <rect
          x="264.04"
          y="21.53"
          width="6.04"
          height="6.04"
          transform="translate(533.96 49.56) rotate(180)"
          fill="#fff"
        />
        <rect
          x="286.03"
          y="43.65"
          width="6.04"
          height="6.04"
          transform="translate(335.55 -241.93) rotate(90)"
          fill="#fff"
        />
        <rect
          x="286.03"
          y="65.63"
          width="6.04"
          height="6.04"
          transform="translate(357.54 -219.94) rotate(90)"
          fill="#fff"
        />
        <rect
          x="286.03"
          y="87.62"
          width="6.04"
          height="6.04"
          transform="translate(379.53 -197.95) rotate(90)"
          fill="#fff"
        />
        <rect
          x="286.03"
          y="109.61"
          width="6.04"
          height="6.04"
          transform="translate(401.52 -175.96) rotate(90)"
          fill="#fff"
        />
        <rect
          x="286.03"
          y="131.6"
          width="6.04"
          height="6.04"
          transform="translate(423.51 -153.97) rotate(90)"
          fill="#fff"
        />
        <rect
          x="264.04"
          y="43.65"
          width="6.04"
          height="6.04"
          transform="translate(313.56 -219.94) rotate(90)"
          fill="#fff"
        />
        <rect
          x="264.04"
          y="65.63"
          width="6.04"
          height="6.04"
          transform="translate(335.55 -197.95) rotate(90)"
          fill="#fff"
        />
        <rect
          x="264.04"
          y="87.62"
          width="6.04"
          height="6.04"
          transform="translate(357.54 -175.96) rotate(90)"
          fill="#fff"
        />
        <rect
          x="264.04"
          y="109.61"
          width="6.04"
          height="6.04"
          transform="translate(379.53 -153.97) rotate(90)"
          fill="#fff"
        />
        <rect
          x="286.03"
          y="153.59"
          width="6.04"
          height="6.04"
          transform="translate(445.5 -131.98) rotate(90)"
          fill="#fff"
        />
        <rect
          x="286.03"
          y="175.58"
          width="6.04"
          height="6.04"
          transform="translate(467.49 -109.99) rotate(90)"
          fill="#fff"
        />
        <rect
          x="286.03"
          y="-0.46"
          width="6.04"
          height="6.04"
          transform="translate(291.45 -286.03) rotate(90)"
          fill="#fff"
        />
        <rect
          x="264.04"
          y="-0.46"
          width="6.04"
          height="6.04"
          transform="translate(269.46 -264.04) rotate(90)"
          fill="#fff"
        />
        <rect
          x="242.05"
          y="21.53"
          width="6.04"
          height="6.04"
          transform="translate(489.98 49.56) rotate(180)"
          fill="#fff"
        />
        <rect
          x="220.06"
          y="21.53"
          width="6.04"
          height="6.04"
          transform="translate(446 49.56) rotate(180)"
          fill="#fff"
        />
        <rect
          x="242.05"
          y="43.65"
          width="6.04"
          height="6.04"
          transform="translate(291.57 -197.95) rotate(90)"
          fill="#fff"
        />
        <rect
          x="242.05"
          y="65.63"
          width="6.04"
          height="6.04"
          transform="translate(313.56 -175.96) rotate(90)"
          fill="#fff"
        />
        <rect
          x="220.06"
          y="43.65"
          width="6.04"
          height="6.04"
          transform="translate(269.58 -175.96) rotate(90)"
          fill="#fff"
        />
        <rect
          x="220.06"
          y="65.63"
          width="6.04"
          height="6.04"
          transform="translate(291.57 -153.97) rotate(90)"
          fill="#fff"
        />
        <rect
          x="242.05"
          y="-0.46"
          width="6.04"
          height="6.04"
          transform="translate(247.47 -242.05) rotate(90)"
          fill="#fff"
        />
        <rect
          x="220.06"
          y="-0.46"
          width="6.04"
          height="6.04"
          transform="translate(225.48 -220.06) rotate(90)"
          fill="#fff"
        />
        <rect
          x="198.08"
          y="21.53"
          width="6.04"
          height="6.04"
          transform="translate(402.02 49.56) rotate(180)"
          fill="#fff"
        />
        <rect
          x="176.09"
          y="21.53"
          width="6.04"
          height="6.04"
          transform="translate(358.04 49.56) rotate(180)"
          fill="#fff"
        />
        <rect
          x="198.08"
          y="43.65"
          width="6.04"
          height="6.04"
          transform="translate(247.59 -153.97) rotate(90)"
          fill="#fff"
        />
        <rect
          x="198.08"
          y="65.63"
          width="6.04"
          height="6.04"
          transform="translate(269.58 -131.98) rotate(90)"
          fill="#fff"
        />
        <rect
          x="176.09"
          y="43.65"
          width="6.04"
          height="6.04"
          transform="translate(225.6 -131.98) rotate(90)"
          fill="#fff"
        />
        <rect
          x="176.09"
          y="65.63"
          width="6.04"
          height="6.04"
          transform="translate(247.59 -109.99) rotate(90)"
          fill="#fff"
        />
        <rect
          x="198.08"
          y="-0.46"
          width="6.04"
          height="6.04"
          transform="translate(203.49 -198.08) rotate(90)"
          fill="#fff"
        />
        <rect
          x="176.09"
          y="-0.46"
          width="6.04"
          height="6.04"
          transform="translate(181.5 -176.09) rotate(90)"
          fill="#fff"
        />
        <rect
          x="154.1"
          y="21.53"
          width="6.04"
          height="6.04"
          transform="translate(314.07 49.56) rotate(180)"
          fill="#fff"
        />
        <rect
          x="132.11"
          y="21.53"
          width="6.04"
          height="6.04"
          transform="translate(270.09 49.56) rotate(180)"
          fill="#fff"
        />
        <rect
          x="154.1"
          y="-0.46"
          width="6.04"
          height="6.04"
          transform="translate(159.51 -154.1) rotate(90)"
          fill="#fff"
        />
        <rect
          x="132.11"
          y="-0.46"
          width="6.04"
          height="6.04"
          transform="translate(137.52 -132.11) rotate(90)"
          fill="#fff"
        />
        <rect
          x="110.12"
          y="21.53"
          width="6.04"
          height="6.04"
          transform="translate(226.11 49.56) rotate(180)"
          fill="#fff"
        />
        <rect
          x="88.13"
          y="21.53"
          width="6.04"
          height="6.04"
          transform="translate(182.13 49.56) rotate(180)"
          fill="#fff"
        />
        <rect
          x="110.12"
          y="-0.46"
          width="6.04"
          height="6.04"
          transform="translate(115.53 -110.12) rotate(90)"
          fill="#fff"
        />
        <rect
          x="88.13"
          y="-0.46"
          width="6.04"
          height="6.04"
          transform="translate(93.54 -88.13) rotate(90)"
          fill="#fff"
        />
        <rect
          x="66.14"
          y="21.53"
          width="6.04"
          height="6.04"
          transform="translate(138.15 49.56) rotate(180)"
          fill="#fff"
        />
        <rect
          x="44.15"
          y="21.53"
          width="6.04"
          height="6.04"
          transform="translate(94.17 49.56) rotate(180)"
          fill="#fff"
        />
        <rect
          x="66.14"
          y="-0.46"
          width="6.04"
          height="6.04"
          transform="translate(71.55 -66.14) rotate(90)"
          fill="#fff"
        />
        <rect
          x="44.15"
          y="-0.46"
          width="6.04"
          height="6.04"
          transform="translate(49.56 -44.15) rotate(90)"
          fill="#fff"
        />
        <rect
          x="22.16"
          y="21.53"
          width="6.04"
          height="6.04"
          transform="translate(50.19 49.56) rotate(180)"
          fill="#fff"
        />
        <rect
          x="0.17"
          y="21.53"
          width="6.04"
          height="6.04"
          transform="translate(6.22 49.56) rotate(180)"
          fill="#fff"
        />
        <rect
          x="22.16"
          y="-0.46"
          width="6.04"
          height="6.04"
          transform="translate(27.57 -22.16) rotate(90)"
          fill="#fff"
        />
        <rect
          x="0.17"
          y="-0.46"
          width="6.04"
          height="6.04"
          transform="translate(5.58 -0.17) rotate(90)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};
